import React, {forwardRef, useEffect, useLayoutEffect, useRef, useState} from "react";
import HomeNavigator from "../Home/HomeNavigator";
import {useLocation} from "react-router-dom";
import {
    EVENT_COPY_DOC_NOTE,
    EVENT_DELETE_HTML_NOTE,
    EVENT_FAVIRIATE_CHANGE,
    EVENT_REFRESH_LIBRARY_LIST,
    EVENT_REFRESH_RECENTS,
    EVENT_RESET_NO_SELECTED,
    EVENT_SWITCH_HOME_LIST_MENU, EVENT_SYNC_CARD_DATA_FROM_PAGECARD,
    EVENT_SYNC_CARD_DATA_FROM_RIGHT_SLIDER,
    EVENT_UPDATE_NOTE,
    FROM_HOME_LIBRARY,
    FROM_JOURNAL,
    FROM_PAGE_CARD, HEADER_HEIGHT,
    LASTEST_NOTE_DOC,
    MENU_SEPARATOR
} from "@/Const";
import {
    createCopyLink,
    formatDate,
    generateUUID2, getCtrlOrAlt,
    getImagePathWithTheme, getImagePathWithThemeSvg,
    getItem,
    isCardEmpty, isCardEmptyCard, isDarkMode, isStringNullOrEmpty,
    MenuItem, removeHtmlTags
} from "@/utils";
import {deleteCard, getCardById, isCardExistInDb, updateCard, updateCardViewTime} from "@model/card";
import Editor from "@/components/EditorV2";
import {postMessage, recvMessage, unSubscribe} from "@/common/event";
import {Dropdown, MenuProps, message, Tooltip} from "antd";
import {noteServer} from "@/common/notesServer";
import {editDoc} from "@model/doc";
import {ipcInvoke, ipcSend} from "@/common/ipc";
import global from "@/global";
import { t } from "i18next";
import {deleteAllCardFromRefProject} from "@model/note";
import {ENoteAction} from "@/views/Note/NoteItem/NoteItemIndex";
import {
    IconAddToFavor, IconAddToProject,
    IconCopyLink, IconDelete,
    IconInfoMenu,
    IconMakeCopy,
    IconManagerTags,
    IconMenuExportItem, IconOpenInPopup, IconRemoveFavor,
    IconRename,
    IconSearch, IconVersionHistory
} from "@/Icon";
import {APP_WEB_WWW} from "@/electron_interactive";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import {useAtom} from "jotai";
import {atomSliderWidth} from "@/App";
import SideBarFold, {atomIsSideBarExpand} from "@/components/EditorV2/SideBarFold/SideBarFold";
import {resetRootPostionNormal, setRootPostionFixed} from "@/Utility0";
import {getCardTitle, getFavorChildrenMenu, isMac, updateFavorToFolder} from "@/Utility";
import {debugLog} from "@/LogUtils";
import {shareCardData} from "@/views/Utils/CardUtils";

const PageCard = forwardRef((props, ref)=>{

    const params = useLocation();
    const editorRef = useRef(null);
    const headingTreeRef = useRef(null);

    const [rightSliderWidth,setRightSliderWidth] = useAtom(atomSliderWidth);
    // const [isSidebarExpand] = useAtom(atomIsSideBarExpand);

    const [editor,setEditor] = useState(null);
    const [cardData,setCardData] = useState<any>();
    const [headerTreeWidth,setHeaderTreeWidth] = useState(0);
    const sideBarFoldRef = useRef(null);
    const [sideBarStatus, setSideBarStatus] = useState<any>(0);
    const divScrollContainer = useRef(null);
    const [isShowMenuMore,setIsShowMenuMore] = useState(false);
    const mEditorRef = useRef(null);

    const MENU_MORE =()=> {
        const arrayMenus = [
            getItem(t("Open in popup"), 'openInPopup', <IconOpenInPopup/>, undefined, undefined, async () => {
                window.showDialogCard(cardData);
            }),
            getItem(t("ExportPDF"), 'exportPdf', <IconMenuExportItem/>, undefined, undefined, async () => {

                const data = await editorRef.current?.getSaveData()
                const name = getCardTitle(data);
                //保存到doc
                editDoc((data.id || LASTEST_NOTE_DOC), data.doc, data.name).then(res => {
                    setTimeout(() => {
                        ipcSend('save-pdf-to-system', (data.id || LASTEST_NOTE_DOC), name)
                    }, 10);
                })
            }),
            getItem(t("ExportMarkdown"), 'exportMarkdown', <IconMenuExportItem/>, undefined, undefined, async () => {
                markdown()
            }),
            getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

            }),
            // getItem(t("ShowInfo"), 'showInfo', null, undefined, undefined, () => {
            //   window.GOpenCountWords();
            // }),
            getItem(t("Rename"), 'rename', <IconRename/>, undefined, undefined, () => {
                // @ts-ignore
                handleMenuClick({key: ENoteAction.rename})
            }),
            getItem(cardData?.isFavirated === 1?t('Cancel favor'):t("Add to Favorites"), 'favor',
                cardData?.isFavirated === 1?<IconRemoveFavor/>:<IconAddToFavor/>,
                getFavorChildrenMenu(cardData?.isFavirated,async (key)=>{
                    const ccccccc = await editorRef.current?.save?.();
                    const updateC = {
                        ...ccccccc,
                        type: ccccccc.type || 'card',
                        favirateTime:Date.now(),
                        isFavirated: (cardData.isFavirated == 1) ? 0 : 1
                    }
                    //更新收藏
                    await updateFavorToFolder(key,updateC);
                    await updateCard(updateC).then(res=>{
                        postMessage(EVENT_FAVIRIATE_CHANGE);
                    });
                    const card = await getCardById(cardData.id, true);
                    setCardData(card);
            }),undefined, async () => {
                const ccccccc = await editorRef.current?.save?.();
                await updateCard({
                    ...ccccccc,
                    type: ccccccc.type || 'card',
                    favirateTime:Date.now(),
                    isFavirated: (cardData.isFavirated == 1) ? 0 : 1
                }).then(res=>{
                    postMessage(EVENT_FAVIRIATE_CHANGE);
                });
                const card = await getCardById(cardData.id, true);
                setCardData(card);
            }),
            getItem(t("Generic copy"), 'makeCopy', <IconMakeCopy/>, undefined, undefined, async () => {
                // @ts-ignore
                handleMenuClick({key: ENoteAction.makeACopy})
            }),
            getItem(t("Search"), 'search', <IconSearch/>, undefined, undefined, () => {
                // @ts-ignore
                handleMenuClick({key: ENoteAction.search})
            }),

            getItem(t("Show info"), 'showInfo', <IconInfoMenu/>, undefined, undefined, async () => {
                const saveData: any = await editorRef.current?.getSaveData();
                cardData.doc = saveData.doc;
                cardData.name = saveData.name;
                cardData.type = cardData.type || 'card';
                if (!cardData.name) {
                    cardData.name = t("Untitled");
                }
                if (!cardData.createTime) {
                    cardData.createTime = Date.now();
                    cardData.updateTime = Date.now();
                }
                window.showInfo('library', cardData)
            }),

            getItem(<div>{t("Version history")}<label className={'beta'}>{'Beta'}</label></div>, 'versionHistory',
                <IconVersionHistory/>, undefined, undefined, () => {
                    window.showDialogCardHistory(cardData.id,(newCard:any)=>{
                        setCardData(newCard);
                    });
                }),

            getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

            }),

            getItem(t("Copy link"), 'copyLink', <IconCopyLink/>, undefined, undefined, () => {
                createCopyLink('library', cardData.id, cardData.type, null);
            }),

            getItem(t("Manage tags"), 'manageTags', <IconManagerTags/>, undefined, undefined, async () => {
                //如果是新建的card,操作标签前先保存这个card
                let card: any = await getCardById(cardData.id, false);
                let ddddddatatataat = cardData;

                if (!card) {
                    // logger('save as a new card....');
                    const ccccccc = await editorRef.current?.save?.();
                    await updateCard({
                        ...ccccccc,
                        type: ccccccc.type || 'card'
                    }, true, true, 'fromManageTag');
                    card = await getCardById(cardData.id, true);
                    setCardData(card);
                    ddddddatatataat = card;
                    global.g_currentNoteData = card;

                    // logger('a new card....');
                    // logger(ddddddatatataat);
                }
                window.showManageTags([ddddddatatataat]);
            }),

            getItem(t("Add to project"), 'addToProject', <IconAddToProject/>, undefined, undefined, async () => {
                const ccccccc = await editorRef.current?.save?.();
                await updateCard({
                    ...cardData,
                    ...ccccccc,
                    type: ccccccc.type || 'card',
                    // isFavirated: cardData.isFavirated,
                    // favirateTime:cardData.favirateTime
                })
                const card:any = await getCardById(cardData.id, true);
                setCardData(card);
                window.showDialogChooseProject([card])
            }),
        ]

        if (cardData?.type != 'journal'){
            arrayMenus.push(
                getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

                }),
            )
            arrayMenus.push(
                getItem(t("Delete"), 'delete', <IconDelete/>, undefined, undefined, () => {
                    // @ts-ignore
                    handleMenuClick({key: ENoteAction.delete})
                }),
            )
        }else{
            for (let i=arrayMenus.length -1;i>=0;i--){
                const item:any = arrayMenus[i];
                if (item.key == 'rename' || item.key == 'makeCopy' || item.key == 'delete' || item.key == 'favor'){
                    arrayMenus.splice(i,1);
                }
            }
        }

        return arrayMenus;
    }

    const handleMenuClick: MenuProps['onClick'] = async (e: any) => {
        const key: ENoteAction = +e.key as ENoteAction
        switch (key) {
            case ENoteAction.makeACopy:
                const noteSimpleData = await editorRef.current?.getSaveData();
                // postMessage(EVENT_COPY_DOC_NOTE, noteSimpleData);
                const newData = {...noteSimpleData};
                newData.id = generateUUID2();
                newData.name += `(${t('Copy')})`
                delete newData.viewTime;
                await updateCard(newData);
                // window.globalRefreshList();//全部刷新...
                // message.info(t("Card copied"))
                message.info(t("Duplicated"));
                window.globalRefreshList('refresh_single_library_item_',newData.id);
                break;
            case ENoteAction.rename:
                editorRef.current?.rename?.()
                break;
            case ENoteAction.delete:
                window.showMessageBox(t("Tips"),t("ConfirmDeleteLibraryItem"),t("Cancel"),t("Delete"),null,async ()=>{
                    const card = await getCardById(cardData.id);
                    if (card){
                        card.isDeleted = 1;
                        card.deleteTime = Date.now();
                        setCardData({...card});
                        await updateCard(card);
                        //删除这个card所关联的项目
                        await deleteAllCardFromRefProject(card);
                        //更新.
                        postMessage(EVENT_REFRESH_LIBRARY_LIST);
                        postMessage(EVENT_REFRESH_RECENTS);
                        history.back();
                    }
                })
                break;
            case ENoteAction.search:
                window.GSearchOpen?.()
                break;
        }
    };

    /**
     * markdown
     */
    async function markdown(){
        // window.showProgress(t("Exporting"))

        const noteSimpleData = await editorRef.current?.getSaveData();
        // const name = getCardTitle(noteSimpleData)
        // editor?.chain().export({
        //     format: 'md',
        //     onExport(context) {
        //         const { blob, error } = context
        //         if(error){
        //             noteServer.openTip("error", t("ExportMarkdownFail"));
        //             return;
        //         }
        //         blob.arrayBuffer().then(arrayBuffer => {
        //             window.closeProgress();
        //
        //             ipcSend('save-markdown-to-system', arrayBuffer, name)
        //         });
        //         // context.download()  该API存在不能自定义 导出文件名的缺陷
        //     },
        // })

        window.exportMarkdown(noteSimpleData);
    }

    /**
     * 窗口大小调整
     * @param event
     */
    function onWindowResize(event:any){
    }

    /**
     * 重置card数据
     */
    async function resetCard(){
        //保存上一个。如果有的话...
        if (editor){
            const data = editorRef.current?.getSaveData();
            const isExist = await isCardExistInDb(data.id);
            if (!isCardEmptyCard(data) || isExist){
                data.viewTime = Date.now();
                updateCard(data).then(res => {
                    postMessage(EVENT_REFRESH_LIBRARY_LIST);
                })
            }
        }
        if (params?.state?.cardId){
            global.g_currentRecentId = params.state.cardId;
            await updateCardViewTime(params.state.cardId);
            postMessage(EVENT_REFRESH_RECENTS);
            getCardById(params.state.cardId)?.then(res=>{
                setCardData(res);
            });
            postMessage(EVENT_RESET_NO_SELECTED);
        }else{
            global.g_currentRecentId = generateUUID2();
            setCardData({id:global.g_currentRecentId,name:'',type:'card'})
        }
        sessionStorage.setItem('note-id', global.g_currentRecentId);
        //刷新目录
        headingTreeRef.current?.onRefreshHeadings();
    }

    /**
     * 按键
     * @param event
     */
    function onKeyDown(event:any){
        // debugLog('keydown',event);

        let szKey = event.key.toLowerCase();
        if ((event.metaKey || event.ctrlKey)){
            if (szKey == KEYS.F){
                handleMenuClick({key: ENoteAction.search})
            }else if (szKey == KEYS.S){
                sideBarFoldRef.current?.onToggleBar();
            }
        }else if (event.key == KEYS.ESCAPE){
            window.closePopupCardList();
        }
    }

    /**
     * 刷新tag
     * @param newData
     */
    window.refreshTag = (newData:any)=>{
        //如果从外面配置了tag ，这里要想办法去刷新。
        if (newData.id == cardData.id){
            var ttttt = {...cardData};
            ttttt.tags = newData.tags;
            setCardData(ttttt);
        }
    }

    /**
     * 装card的滚动
     */
    window.getCardScrollContainer = ()=>{
        return divScrollContainer.current;
    }

    useEffect(()=>{
        resetCard().then(res=>{
            //标题获得焦点
            document.querySelector('#NOTE_TITLE_INPUT')?.focus?.()
        })
    },[params])

    useEffect(() => {
        setRootPostionFixed();
        window.addEventListener('resize',onWindowResize);

        return ()=>{
            sessionStorage.removeItem('note-id');
            window.removeEventListener('resize',onWindowResize);
            delete window.refreshTag;
            delete window.getCardScrollContainer;
            window.closeAddNoteWindow();
            ipcInvoke('update-backup-time');
        }
    }, []);

    useEffect(()=>{

        document.body.addEventListener('keydown',onKeyDown);

        //接收update消息
        recvMessage(EVENT_SYNC_CARD_DATA_FROM_RIGHT_SLIDER,(msg,data)=>{
            const card = data.data.data;
            if (cardData?.id == card.id){
                const isEmptyTitle = isStringNullOrEmpty(card.name) || card.name.toLowerCase() == t("Untitled").toLowerCase();
                if (isStringNullOrEmpty(removeHtmlTags(card.doc)) && isEmptyTitle && card.doc.indexOf('<img') == -1){
                    return;
                }

                card.type = card.type || 'card';
                setCardData(card);
                // updateCard(card,true,true,'fromCanvasListIndex-EVENT_UPDATE_NOTE').then((res)=>{
                //
                // });
            }
        })

        return ()=>{
            unSubscribe(EVENT_SYNC_CARD_DATA_FROM_RIGHT_SLIDER);
            document.body.removeEventListener('keydown',onKeyDown);
        }
    })

    useLayoutEffect(()=>{
        return ()=>{
            resetRootPostionNormal();
            //保存....
            saveCard();
        }
    },[])

    async function saveCard(){
        const data = editorRef.current?.getSaveData();
        if (!data.type){
            //要保证所有的页面可以打开所有的东西。不要尝试固定任何类型。有可能今天打开A，明天打开B，后天打开C
            data.type = 'card';
        }

        const isExist = await isCardExistInDb(data.id);
        if (!isCardEmptyCard(data) || isExist){
            // data.viewTime = Date.now();
            if (global.g_closedId == data.id){
                data.viewTime = 1;
            }else{
                data.viewTime = Date.now();
            }
            global.g_closedId = 0;
            updateCard(data).then(res=>{
                postMessage(EVENT_REFRESH_LIBRARY_LIST);
                postMessage(EVENT_REFRESH_RECENTS);
            })
        }
    }


    const updateAndRefreshSom = (data:any)=>{

    }

    const patchMenuFavor = ()=>{
        setTimeout(()=>{
            const arrayMenus = document.getElementsByClassName('ant-dropdown-menu-submenu-title');
            for (let i=0;i<arrayMenus.length;i++){
                const item = arrayMenus[i];
                if (item.dataset?.menuId?.endsWith('-favor')){
                    item.onclick = async function (event:any){
                        const ccccccc = await editorRef.current?.save?.();
                        await updateCard({
                            ...ccccccc,
                            type: ccccccc.type || 'card',
                            favirateTime:Date.now(),
                            isFavirated: (cardData.isFavirated == 1) ? 0 : 1
                        }).then(res=>{
                            postMessage(EVENT_FAVIRIATE_CHANGE);
                        });
                        const card = await getCardById(cardData.id, true);
                        setCardData(card);
                        setIsShowMenuMore(false);
                    }
                }
            }
        },100)
    }


    return(
        <div style={{display:'flex',height:'100%'}}>
            {/*left*/}
            <div style={{height:'100%',flex:'1'}}>
                <div className={'flex-row-vertical-center'} style={{height: `${HEADER_HEIGHT}px`,paddingTop:'1px',paddingRight:'16px', borderBottom:'1px solid var(--card-bar-line-color)',background:'var(--background-color-f9fafb)'}}>
                    <HomeNavigator margin={'0 0px 0 16px'}/>
                    <Tooltip overlayClassName='font-size-12' title={
                        <div>{t("Table of content")}<span className={'tooltip-shortcut-key'}>{getCtrlOrAlt("Ctrl + S")}</span></div>} arrow={false}>
                        <img className='img-32 hovered-gray-radius ml-10' onClick={() => {
                            sideBarFoldRef.current?.onToggleBar();
                        }} src={getImagePathWithTheme('left_slider_2.svg')}/>
                    </Tooltip>
                    <div style={{flexGrow: '1'}}></div>
                    <Tooltip title={t('Info')} arrow={false}>
                        <img className="img-32 hovered-gray-radius ml-10" src={getImagePathWithTheme('dialog_card_new_info.svg')} onClick={(e)=>{
                            window.showInfo('library',cardData);
                        }}/>
                    </Tooltip>
                    {/*分享 发布*/}
                    <Tooltip overlayClassName='font-size-12' title={t('Share1')} zIndex={9999} arrow={false}>
                        <img className='img-32 hovered-gray-radius ml-8' onMouseDown={()=>{

                        }} onClick={() => {
                            window.showDialogPublishCardToWeb(cardData.id,async (szId,dialogPublishToWebRef)=>{
                                if (szId == 'exportPdf') {

                                    const data = editorRef.current?.getSaveData();
                                    const name = getCardTitle(data);
                                    //保存到doc
                                    editDoc((data.id || LASTEST_NOTE_DOC),data.doc,data.name).then(res=>{
                                        setTimeout(() => {
                                            ipcSend('save-pdf-to-system', (data.id || LASTEST_NOTE_DOC), name)
                                        }, 10);
                                    })
                                }else if (szId == 'exportMarkdown'){
                                    markdown();
                                }
                                else {
                                    const newData = await editorRef.current?.getSaveData();
                                    shareCardData(newData,null,dialogPublishToWebRef);
                                }
                            });
                        }} src={getImagePathWithThemeSvg('share_card')}/>
                    </Tooltip>
                    <Dropdown trigger={['click']} open={isShowMenuMore} onOpenChange={(e) => {
                        setIsShowMenuMore(e);
                        patchMenuFavor();
                    }} menu={{items: MENU_MORE()}}>
                        <img className={'img-32 cursor-pointer ml-8'} style={{marginRight: '0px'}}
                             src={getImagePathWithTheme('library_more_1.svg')}/>
                    </Dropdown>
                    {
                        rightSliderWidth == 0 &&
                        <img className='img-32 hovered-gray-radius'
                             style={{marginLeft: APP_WEB_WWW ? '8px' : '8px', marginRight: '-4px'}}
                             src={getImagePathWithTheme('home_slider_library.svg')} onClick={() => {
                            window.openRightSlider(null, 'card',{info:cardData});
                        }}/>
                    }
                </div>
                <div id={'CARD_NOTE_V2_DOM'} className={'editor-card-container------'}
                     style={{ display: 'flex', height:'100%',width:'100%',background:isDarkMode()?'#191B1F':'#FFFFFF'}}>
                    <div style={{position: 'relative', /*minWidth: `${headerTreeWidth}px`,*/overflow:'hidden',width:rightSliderWidth>0?'15%':'15%',display:sideBarStatus == 2?'inherit':'none',maxWidth:'240px',minWidth:'240px'}}>
                        {
                            editor &&
                            // <HeadingTree ref={headingTreeRef} editor={editor} from={FROM_PAGE_CARD} onCollapseCallback={(isExpand: boolean) => {
                            //     if (isExpand) {
                            //         setHeaderTreeWidth(250)
                            //     } else {
                            //         setHeaderTreeWidth(0)
                            //     }
                            // }}/>
                            <SideBarFold ref={sideBarFoldRef} editor={editor} from={FROM_PAGE_CARD} data={cardData} onCollapseCallback={(sidebarStatus:any)=>{
                                if (sidebarStatus) {
                                    setHeaderTreeWidth(250)
                                } else {
                                    setHeaderTreeWidth(0)
                                }
                                setSideBarStatus(sidebarStatus);
                                editorRef.current?.onUpdateSidebarStatus(sidebarStatus);
                            }}/>
                        }
                    </div>

                    <div id={'div-editor-scroll-container'} ref={divScrollContainer} onMouseDown={(e)=>{
                        //关闭图片的弹出菜单
                        // if (window.closeImgAction) {
                        //     window.closeImgAction();
                        // }
                        if (mEditorRef.current && e.target?.classList?.contains('tiptap-outer-sider-div-for-test-click')){
                            mEditorRef.current.chain().focus().setTextSelection(mEditorRef.current.state.selection.from).run();
                            // mEditorRef.current.commands.blur();
                        }
                    }} className={'flex-col tiptap-outer-sider-div-for-test-click'} style={{
                        flexGrow: '1',
                        flexShrink:'0',
                        marginTop: '56px',
                        width:rightSliderWidth>0?'1%':'1%',//设置1%也可以拉伸到全部
                        // marginLeft: headerTreeWidth > 0 ? '100px' : '0px',
                        marginRight: '0',
                        paddingRight: (rightSliderWidth>0 && sideBarStatus == 2)?'2%':'15%',
                        paddingLeft:(rightSliderWidth>0 && sideBarStatus == 2)?'2%':'15%',
                        height:isMac()?'calc(100vh - 120px)':'calc(100vh - 153px)',
                        overflowY:'auto'
                    }}>
                        <Editor ref={editorRef} data={cardData} from={FROM_PAGE_CARD} subFrom={FROM_PAGE_CARD} source={'pageCard'} onSaveData={(data: any) => {
                            //保存....
                            if (!data.type) {
                                data.type = 'card';
                            }
                            if (data.id) {
                                updateAndRefreshSom(data)
                            } else {
                                if (!isCardEmpty(data.doc)) {
                                    data.id = 'j-' + generateUUID2();
                                    updateAndRefreshSom(data);
                                }
                            }

                        }} onEmptyData={(data: any) => {

                        }} onInitComplete={(editor: any) => {
                            mEditorRef.current = editor;
                            setEditor(editor);
                        }} onUpdate={(data:any)=>{
                            postMessage(EVENT_SYNC_CARD_DATA_FROM_PAGECARD, {data: {...data}});
                            //更新..
                            updateCard(data);
                        }}/>
                    </div>

                </div>
            </div>

            {/*right*/}
            <div style={{width:`${rightSliderWidth}px`}}/>
        </div>
    )
})

export default PageCard;